<slick-dialog key="DIALOG_SITE_LOG_ASSET_PHOTOS" [header]="assetName + ' — ' + photoTypeLabel" width="520" #photosDialog>
	<div *ngIf="isLoading" class="text-muted p-2">Loading photos...</div>
	<div *ngIf="!isLoading">
		<slick-file-list [files]="photos"
			[showCheckboxes]="false"
			[showPhotoGallery]="true"
			[allowDelete]="true"
			(onFileChanged)="onFileChanged($event)"
			(onFileDelete)="onFileDeleted($event)"
			(onFileClicked)="onDocumentClicked($event)"></slick-file-list>
		<slick-file-drop class="mt-2"
			displayText="Drop photos here or click to upload."
			(filesChanged)="onNewFilesAdded($event)"></slick-file-drop>
	</div>
	<div class="mt-3 text-end">
		<button type="button" class="btn btn-outline-secondary btn-sm" (click)="close()">Close</button>
	</div>
</slick-dialog>
